<template>
  <div class="rounded-full text-sm text-light-950 w-14 p-1 cursor-pointer" :class="selected?.background" @click="emit('update:modelValue', !modelValue)">
    <ButtonBase
      class="!block duration-300 ease-out shrink-0"
      v-bind="{ ...button, ...(selected?.button || {}) }"
      style-type="round"
      :size="button?.size"
      :style="{
        transform: `translateX(${(isInvert ? !modelValue : modelValue) ? '100%' : '0%'})`,
      }"
    />
  </div>
</template>

<script lang="ts" setup>
interface ButtonOption {
  background?: string
  value: boolean
  button?: {
    size?: string,
    color?: string
  }
}

const props = defineProps<{
  modelValue: boolean
  options: ButtonOption[]
  isInvert?: boolean
  button?: {
    size?: string,
    color?: string
  }
}>()

const emit = defineEmits([ 'update:modelValue' ])

const { modelValue } = toRefs(props)

const selected = computed(() => props.options.find(o => o.value == props.modelValue))
</script>